// extracted by mini-css-extract-plugin
export const atlasGrotesk = "'AtlasGrotesk'";
export const bold = "700";
export const content = "Onboarding__content__EHui+";
export const headBgColorExternal = "var(--salt)";
export const headBgColorInternal = "var(--shade)";
export const headBgColorShrunkSidebar = "var(--slate)";
export const main = "Onboarding__main__Le6Fu";
export const medium = "500";
export const onboarding = "Onboarding__onboarding__pDvSu";
export const profileCompact = "Onboarding__profileCompact__BdLYk";
export const regular = "400";
export const sans = "'sans'";
export const semibold = "600";
export const serif = "'serif'";
export const textCenter = "Onboarding__textCenter__UAQjc";
export const wider = "Onboarding__wider__AFo0w";